// namespace
export const NAMESPACE = 'auth';

// actions
export const CHECK_AUTH = 'CHECK_AUTH';
export const LOGIN = 'LOGIN';
export const LOGIN_PROVIDER = 'LOGIN_PROVIDER';
export const LOGOUT = 'LOGOUT';
export const SET_TOKEN = 'SET_TOKEN';
export const REGISTER = 'REGISTER';
export const REGISTER_MOBILE = 'REGISTER_MOBILE';
export const REGISTER_OWNER = 'REGISTER_OWNER';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_DEVICE_INFO = 'UPDATE_USER_DEVICE_INFO';
export const DELETE_USER_DEVICE_INFO = 'DELETE_USER_DEVICE_INFO';
export const AUTH_REQ = 'AUTH_REQ';
export const AUTH_CONFIRM = 'AUTH_CONFIRM';
export const REGISTER_OAUTH = 'REGISTER_OAUTH';
export const SOCIAL_REGISTER = 'SOCIAL_REGISTER';
export const SOCIAL_CHECK = 'SOCIAL_CHECK';

// mutations
export const PURGE_AUTH = 'PURGE_AUTH';
export const SET_ERROR = 'SET_ERROR';
export const SET_AUTH = 'SET_AUTH';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_AUTH_REQ = 'SET_AUTH_REQ';

export const getName = name => `${NAMESPACE}/${name}`;
export const ROOT_CHECK_AUTH = getName(CHECK_AUTH);
export const ROOT_UPDATE_USER_DEVICE_INFO = getName(UPDATE_USER_DEVICE_INFO);

/*export interface State {
  errors: any;
  user: any;
  isAuthenticated: boolean;
}*/
